import { Grid, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import ActiveUsersChart from '../components/Analytics/ActiveUsersChart'
import AgentFilterSelect from '../components/Analytics/AgentFilterSelect'
import AnalyticsLayout from '../components/Analytics/AnalyticsLayout'
import ConversationsChart from '../components/Analytics/ConversationsChart'
import FeedbackDonutChart from '../components/Analytics/FeedbackDonutChart'
import MessagesChart from '../components/Analytics/MessagesChart'
import NegativeFeedbackTable from '../components/Analytics/NegativeFeedbackTable'
import { AgentFilter } from '../types/analyticsTypes'

const AnalyticsPage: React.FC = () => {
  const [agentId, setAgentId] = useState<AgentFilter>(null)

  return (
    <AnalyticsLayout headerAction={<AgentFilterSelect value={agentId} onChange={setAgentId} />}>
      <VStack align='stretch' spacing={6}>
        <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={6}>
          <FeedbackDonutChart agentId={agentId} />
          <ActiveUsersChart agentId={agentId} />
          <ConversationsChart agentId={agentId} />
          <MessagesChart agentId={agentId} />
        </Grid>
        <NegativeFeedbackTable agentId={agentId} />
      </VStack>
    </AnalyticsLayout>
  )
}

export default AnalyticsPage
